import React, {useEffect, useState} from 'react';
import {
  Card,
  Theme,
  makeStyles,
  createStyles,
  CardContent,
  Typography
} from '@material-ui/core';
import {useTranslation} from 'react-i18next';
import {connect, useDispatch} from 'react-redux';

// payment Reducer
import {
  _guarantorLogin,
  _paymentMethodId,
  _setPayInInstallmentDetails
} from '@shared/store/actions/PaymentActions';
// components
import BackNavigation from '../backNavigation/BackNavigation';
import NavRoutes from 'src/constants/route/NavRoutes';
import './PaymentsSectionStyles.scss';
import PaymentsMethod from '../PaymentsMethods/PaymentsMethods';
import MailCheck from '../mailcheck/MailCheck';
import CardPaymentDashboard from '../CardPaymentDashboard/CardPaymentDashboard';
// constants
const {innerWidth: width} = window;
const isDesktop = width >= 1024 ? true : false;
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    card: {
      borderRadius: 0,
      ackgroundColor: theme.palette.primary.light,
      color: theme.palette.primary.contrastText,
      boxShadow: 'none'
    },
    flex: {
      flex: 1,
      display: 'flex'
    }
  })
);
const PaymentsSection = (props: any): React.ReactElement => {
  const {history, match, isLogin} = props;
  const classes = useStyles();
  const {t} = useTranslation();
  const [cardPayment, setCardPayment] = useState(isDesktop ? true : false);
  const [mailCheck, setMailCheck] = useState(false);
  const token = match.params.token;
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isLogin) {
      props._guarantorLogin(false);
      if (token) {
        history.push(`/${NavRoutes.PUBLIC.PAYMENTS_LOGIN}/pay/${token}`);
      }
      return;
    }
    if (isDesktop) {
      props._paymentMethodId(1);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const backNavigation = (): void => {
    // history.push(`${NavRoutes.PUBLIC.PAYMENTS_DASHBOARD}/${token}`);
    const details = {
      instalment_start_date: null,
      min_instalment_amount: null,
      total_installments: null,
      pay_in_installments_selected: false,
      next_installment_date: null,
      plan_frequency: ''
    };
    dispatch(_setPayInInstallmentDetails(details));

    history.push(`/${NavRoutes.PUBLIC.PAYMENTS_DASHBOARD}/${token}`);
  };

  const navigateToCardPayment = (id: any, key: any): void => {
    if (isDesktop) {
      if (id === 1) {
        setCardPayment(true);
        setMailCheck(false);
        props._paymentMethodId(id);
      } else {
        setCardPayment(false);
        setMailCheck(true);
        props._paymentMethodId(id);
      }
    } else {
      if (id == 1) {
        // history.push(`${NavRoutes.PUBLIC.CARD_PAYMENT_DASHBOARD}/${token}`);
        history.push(`/${NavRoutes.PUBLIC.CARD_PAYMENT_DASHBOARD}/${token}`);
      } else if (id == 2) {
        // history.push(`${NavRoutes.PUBLIC.MAIL_CHECK}/${token}`);
        history.push(`/${NavRoutes.PUBLIC.MAIL_CHECK}/${token}`);
      }
    }
  };

  const renderPaymentMethods = () => {
    const methods = [
      {
        id: 1,
        name: 'Credit/Debit card'
      },
      {
        id: 2,
        name: 'Mail Check'
      }
    ];
    return methods.map((element: any, index: any) => (
      <div
        data-test-id={`pcl-guarantor-paymentMethod${element.id}`}
        onClick={(): void => navigateToCardPayment(element.id, index)}
        key={index}>
        <PaymentsMethod {...element} paymentId={element.id} />
      </div>
    ));
  };
  return (
    <div className="payments-section-wrapper">
      <div className={classes.flex}>
        <Card
          className={[
            'payments-section-content-wrap',
            classes.card,
            classes.flex
          ].join(' ')}>
          <CardContent className="content">
            <div className="payments-section-content-view">
              <Typography className="details-view" component={'div'}>
                <BackNavigation navigateTo={backNavigation} />
              </Typography>
              <Typography className="info-text input-header" component={'div'}>
                {t('PAYMENTS_LOGIN.SEND_MAIL.SELECT_PAYMENT_SECTION')}
              </Typography>
              {renderPaymentMethods()}
            </div>
          </CardContent>
        </Card>
      </div>
      {isDesktop && cardPayment && (
        <div className={classes.flex}>
          <CardPaymentDashboard history={history} match={match} />
        </div>
      )}
      {isDesktop && mailCheck && (
        <div className={classes.flex}>
          <MailCheck history={history} match={match} />
        </div>
      )}
    </div>
  );
};

function mapStateToProps(state: any): any {
  return {
    isLogin: state.payments.isLogin
  };
}

export default connect(mapStateToProps, {
  _guarantorLogin,
  _paymentMethodId
})(PaymentsSection);
